import { jsx as r, jsxs as s } from "react/jsx-runtime";
import "styled-components";
import { useThemeInMode as d } from "../../../../context/theme/hooks.js";
import "../../../layout/Stack/Stack.js";
import t from "../../../layout/Box/Box.js";
import "react";
import "../../../../index-CZ8zjHGv.js";
import "../../../layout/Center/Center.js";
import e from "../../../layout/Column/Column.js";
import c from "../../../layout/Columns/Columns.js";
import "../../../layout/Columns/ColumnsContext.js";
import "../../../../context/WindowSize/Dimensions.js";
import "lodash-es";
import i from "../../../typography/Text/Text.js";
import "../../../../context/Text.js";
import "../../../../context/Typography.js";
import "../../../../hooks/link/index.js";
function v({
  removeable: o,
  onClickRemove: m,
  dataNoTranslate: a,
  children: l
}) {
  const n = d();
  return /* @__PURE__ */ r(
    t,
    {
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      height: "fit-content",
      paddingX: "xlarge",
      paddingY: "small",
      borderRadius: "small",
      backgroundColor: n["primary-medium-surface"],
      whiteSpace: "nowrap",
      children: /* @__PURE__ */ s(c, { space: "large", alignY: "center", children: [
        /* @__PURE__ */ r(e, { width: "2/3", alignX: "flex-start", children: /* @__PURE__ */ r(
          i,
          {
            dataNoTranslate: a || void 0,
            size: "small",
            weight: "bold",
            tone: "primary",
            children: l
          }
        ) }),
        /* @__PURE__ */ r(e, { width: "1/3", alignX: "flex-start", children: o && /* @__PURE__ */ r(
          t,
          {
            alignItems: "center",
            onClick: (p) => {
              p.stopPropagation(), m();
            },
            children: /* @__PURE__ */ r(i, { size: "small", tone: "primary", children: "✕" })
          }
        ) })
      ] })
    }
  );
}
export {
  v as default
};
